import i18n from '@/i18n'

export default [
    {
        value: 'has_trigger_goal',
        label: i18n.t('form.label.triggerGoal'),
    },
    {
        value: 'common_target',
        label: i18n.t('targets.commonTarget'),
    },
    {
        value: 'target_library',
        label: i18n.t('targets.libraryTarget'),
    },
]
